import { useContext } from 'react'

import classNames from 'classnames'
import { Field, useField } from 'formik'
import { AppQuizUsageQuestionTrueFalse } from 'globalTypes'

import CoverImage from 'Root/App/CoverImage'
import PageLinkWrapper from 'Root/App/Quiz/PageLinkWrapper'
import { Context as StateContext } from 'Root/App/Quiz/StateContext'
import Title from 'Root/App/Title'
import get from 'lodash/get'
import isNil from 'lodash/isNil'

import FailureFeedback from '../../Feedback/Failure'
import SuccessFeedback from '../../Feedback/Success'
import styles from './index.module.css'

interface Props {
  question: AppQuizUsageQuestionTrueFalse
}

const TrueFalse = ({ question }: Props) => {
  const {
    state: { answers, content },
  } = useContext(StateContext)
  const [field, _meta, helpers] = useField<boolean>(`answers.${question.id}`)

  const answer = get(answers, question.id)

  const { name, value } = field
  const { setValue, setTouched } = helpers

  const onChange = (value) => () => {
    setValue(value)
    setTouched(true)
  }

  const hasAnswered = !isNil(value) && answer === value

  const displayValidation = content.showAnswer && hasAnswered
  const hasAnsweredCorrectly = hasAnswered && answer === question.isTrue

  const displaySuccessFeedback =
    hasAnsweredCorrectly && Boolean(question.successFeedback)
  const displayFailureFeedback =
    hasAnswered && !hasAnsweredCorrectly && Boolean(question.failureFeedback)

  return (
    <div className={styles.container}>
      <PageLinkWrapper slug={content.slug}>
        <Title>{question.title}</Title>
      </PageLinkWrapper>

      {Boolean(question.image) && <CoverImage imageUrl={question.image} />}

      {displaySuccessFeedback && (
        <SuccessFeedback>{question.successFeedback}</SuccessFeedback>
      )}
      {displayFailureFeedback && (
        <FailureFeedback>{question.failureFeedback}</FailureFeedback>
      )}

      <div className={styles.container}>
        <label
          className={classNames(styles.label, {
            'cursor-pointer': !displayValidation,
            'border-2 border-green-700': displayValidation && question.isTrue,
          })}
          htmlFor={`${name}.true`}
        >
          <div className="inline-flex">
            <Field
              checked={value === true}
              className={classNames('form-checkbox', styles.input, {
                'cursor-pointer': !displayValidation,
              })}
              id={`${name}.true`}
              name={name}
              onChange={onChange(true)}
              type="checkbox"
              disabled={displayValidation}
            />
          </div>
          <div>Vero</div>
        </label>
        <label
          className={classNames(styles.label, {
            'cursor-pointer': !displayValidation,
            'border-2 border-green-700': displayValidation && !question.isTrue,
          })}
          htmlFor={`${field.name}.false`}
        >
          <div className="inline-flex">
            <Field
              checked={value === false}
              className={classNames('form-checkbox', styles.input, {
                'cursor-pointer': !displayValidation,
              })}
              id={`${name}.false`}
              name={name}
              onChange={onChange(false)}
              type="checkbox"
              disabled={displayValidation}
            />
          </div>
          <div>Falso</div>
        </label>
      </div>
    </div>
  )
}

export default TrueFalse
